import React from 'react';
import IconButtonV2 from '@/ctComponents/IconButton/IconButtonV2';
import Tooltip from '@/components/Tooltip';
import {
  EllipsisVertical,
  ReceiptText,
  Settings,
  FileCheck,
} from 'lucide-react';

const TableActions = ({
  member,
  hasChanges,
  onUpdateSubscription,
  onOpenSettings,
  onOpenActionMenu,
  handlePaymentHistory,
}) => {
  return (
    <div className="flex items-center gap-2 justify-center">
      <Tooltip
        tooltipId={`member-update-subscription-${member.id}`}
        iconId={`member-update-subscription-icon-${member.id}`}
        arrow
        title={`Update User Subscription${
          hasChanges ? ' (Changes Pending)' : ''
        }`}
        placement="top">
        <IconButtonV2
          disabled={!hasChanges}
          onClick={(e) => {
            e.stopPropagation();
            onUpdateSubscription(member.id);
          }}
          size="small">
          <FileCheck className="w-4 h-4" />
        </IconButtonV2>
      </Tooltip>

      <Tooltip
        tooltipId={`member-access-level-${member.id}`}
        iconId={`member-access-level-icon-${member.id}`}
        arrow
        title="Access Level"
        placement="top">
        <IconButtonV2
          onClick={(e) => {
            e.stopPropagation();
            onOpenSettings(member);
          }}
          size="small">
          <Settings className="w-4 h-4" />
        </IconButtonV2>
      </Tooltip>
      <Tooltip
        tooltipId={`member-billing-${member.id}`}
        iconId={`member-billing-icon-${member.id}`}
        arrow
        title="Billing"
        placement="top">
        <IconButtonV2
          onClick={(e) => {
            e.stopPropagation();
            handlePaymentHistory(member.id);
          }}
          size="small">
          <ReceiptText className="w-4 h-4" />
        </IconButtonV2>
      </Tooltip>

      <Tooltip
        tooltipId={`member-action-${member.id}`}
        iconId={`member-action-icon-${member.id}`}
        arrow
        title="Actions"
        placement="top">
        <IconButtonV2 onClick={(e) => onOpenActionMenu(e, member)} size="small">
          <EllipsisVertical className="w-4 h-4" />
        </IconButtonV2>
      </Tooltip>
    </div>
  );
};

export default TableActions;
